import { attr, belongsTo, hasMany } from 'spraypaint'
import ApplicationRecord from './ApplicationRecord'

const Option = ApplicationRecord.extend({
  static: {
    jsonapiType: 'options',
  },
  attrs: {
    name: attr(),
    slug: attr(),
    poses: attr(),
    without: attr(),
    download: attr(),
    bestValue: attr(),
    abbreviation: attr(),
    displayType: attr(),
    superValue: attr(),
    emailPicture: attr(),
    appointmentValue: attr(),
    code: attr(),
    featured: attr(),
    additionalPoseCharge: attr(),
    imageUrl: attr(),
    buyAllBannerUrl: attr(),
    price: attr({ persist: false }),
    packageId: attr(),
    digitalImagesOnly: attr(),
    createdAt: attr({ persist: false }),
    updatedAt: attr({ persist: false }),
    package: belongsTo(),
    imageTypes: hasMany(),
    prices: hasMany(),
    orderPackages: hasMany(),
    extras: hasMany(),
    tagline: attr(),
    description: attr(),
    isBuyAll: attr(),
    seniorBuyAllPromo: attr(),
  },
})

export default Option
